module.exports = __webpack_public_path__ + "img/nolan-split-files.8c2f5dfc.svg";